module.exports = __webpack_public_path__ + "static/media/637.b849b373.webp";